import React from 'react'
import { Link } from 'react-router-dom'
import Slider from "react-slick";

export default function GoaRoom() {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: true,
        cssEase: "ease",
    };

  return (
    <>
     <section className="goa-rooms">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-8 col-md-9">
                    <div className="goa-shapeheading">
                        <h2 className='heading'>De Coração Suites & Rooms</h2>
                        <img src="/image/bigimage-shape.webp" alt="shape" loading="lazy"/>
                        <p>More than just a place to sleep, our suites and rooms are private spaces designed to soothe. We’ve blended modern elegance with the warmth of a coastal home, creating spaces where you can truly unplug. From the softest linens to views that invite the outdoors in, every corner is crafted for your peace of mind.</p>
                    </div>
                </div>
            </div>

            <div className="row justify-content-between">
                <div className="col-lg-6 col-md-6 col-sm-7">
                    <Slider {...settings} className="goaroom-slider">
                        <Link to="/resort-de-coracao-goa/standard-room" className="goaroom-box">
                            <div>
                                <img src="/image/goahome-room-1.webp" loading="lazy" className="img-responsive" alt="goa room"/>
                            </div>
                            <span>Standard Room</span> 
                            <p>A cozy and practical space designed for a restful stay, featuring essential amenities and comfortable interiors for the savvy traveler.</p>
                        </Link>

                        <Link to="/resort-de-coracao-goa/deluxe-room" className="goaroom-box">
                            <div>
                                <img src="/image/goahome-room-2.webp" loading="lazy" className="img-responsive" alt="goa room"/>
                            </div>
                            <span>Deluxe Room</span> 
                            <p>Bright and inviting, these rooms offer a perfect blend of modern comfort and coastal warmth, ideal for a relaxing getaway.</p>
                        </Link>

                        <Link to="/resort-de-coracao-goa/super-deluxe-room" className="goaroom-box">
                            <div>
                                <img src="/image/goahome-room-3.webp" loading="lazy" className="img-responsive" alt="goa room"/>
                            </div>
                            <span>Super Deluxe Room</span> 
                            <p>Elevate your stay with enhanced space and thoughtful details, designed to provide a higher level of relaxation and luxury.</p>
                        </Link>

                        <Link to="/resort-de-coracao-goa/premium-room" className="goaroom-box">
                            <div>
                                <img src="/image/goahome-room-4.webp" loading="lazy" className="img-responsive" alt="goa room"/>
                            </div>
                            <span>Premium Room</span> 
                            <p>Experience superior comfort in our expansive premium rooms, featuring high-end finishes and a layout built for ultimate unwinding.</p>
                        </Link>

                        <Link to="/resort-de-coracao-goa/suite-room" className="goaroom-box">
                            <div>
                                <img src="/image/goahome-room-5.webp" loading="lazy" className="img-responsive" alt="goa room"/>
                            </div>
                            <span>Suite Room</span> 
                            <p>Our most spacious stay, offering a separate living area and master bedroom for those seeking a genuine home-away-from-home experience.</p>
                        </Link>

                        {/* <Link to="/resort-de-coracao-goa/corner-deluxe-room" className="goaroom-box">
                            <div>
                                <img src="/image/goahome-room-6.webp" loading="lazy" className="img-responsive" alt="goa room"/>
                            </div>
                            <span>Corner Deluxe Room</span> 
                            <p>Enjoy a bright and airy corner retreat featuring dual-aspect views and enhanced privacy, designed for those who appreciate natural light and extra space.</p>
                        </Link> */}
                    </Slider>
                    
                    <Link to="/resort-de-coracao-goa/room-listing" className="default-btn">View All Rooms</Link>
                </div>

                <div className="col-lg-5 col-md-5 col-sm-5">
                    <div className="goaroom-imagebox">
                        <img src="/image/goaroom-image.webp" className="img-responsive" alt="room" loading="lazy"/>
                    </div>
                </div>
            </div>

        </div>
    </section>   
    </>
  )
}
